<script>
    import { createEventDispatcher } from 'svelte';
    import Icon from './Icon.svelte';
    export let foodName = "Burger";
    export let mainingredients = "Beef, Bread, Lettuce, Tomato, Cheese";
    export let country = "Germany";
    export let flavor = "Savory";
    export let description = "A dish";

    const dispatch = createEventDispatcher();

    function FlipElement(){
        dispatch('view', {
		    text: 'c'
	    });
    }
</script>
<div class="surrounding">
    <div class="base">
        <b class="foodName">{foodName}</b>
        <div class="description"><b>Description:</b> {description}</div>
        <div class="description"><b>Main Ingredients:</b> {mainingredients}</div>
        <div class="description"><b>Country of Origin:</b> {country}</div>
        <div class="description"><b>Flavor:</b> {flavor}</div>
        <b class="explore">Explore:</b>
        <div class="icons">
            <Icon image="images/logos/doordash.png" link="https://www.doordash.com/search/store/{foodName}?event_type=search"></Icon>
            <Icon image="images/logos/allrecipes.png"link="https://www.allrecipes.com/search?q={foodName}"></Icon>
            <Icon image="images/logos/ubereats.svg" link="https://www.ubereats.com/search?diningMode=DELIVERY&q={foodName}"></Icon>
            <Icon image="images/logos/googlemaps.png" link="https://www.google.com/maps/search/{foodName}/"></Icon>
        </div>
        <div class="viewcontainer">
            <button class="viewbutton" on:click={FlipElement}>
                <img src="images/EyeView.svg" alt="View Details" class="eye">
                <p class="viewdetails">View Overview</p>
            </button>
        </div>
    </div>
</div>


<style>
    .surrounding{
        display: flex;
		justify-content: center;
		align-content: center;
		align-items: center;
    }
    .base{
        background-color: #1B1B1B;
        color: whitesmoke;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-around;
        border-radius: 5em;
        min-height: 80vh;
        height: 80vh;
        margin-top: 5vh;
        margin-bottom: 10vh;
        padding-left: 7vw;
        padding-right: 7vw;
        min-width: 30vw;
        max-width: 70vw;
    }
    .foodName{
        color: whitesmoke;
        font-size: 45px;
        margin: 0;
        user-select: none;
    }
    .viewdetails{
        color: whitesmoke;
        font-size: 2em;
        align-self: center;
        user-select: none;
    }
    .eye{
        width: 10em;
        height: 4em;
        align-self: center;
        user-select: none;
    }
    .description{
        font-size: 1.7em;
        white-space: pre-wrap;
        user-select: none;
    }
    .explore{
        font-size: 2.5em;
        user-select: none;
    }
    .icons{
        text-align: center;
        display: flex;
        flex-direction: row;
        min-width: 90%;
        justify-content: space-between;
        align-content: space-between;
    }
    @media only screen and (max-width: 900px) {
        .foodName{
            font-size: 40px;
            margin: 0;
        }
        .base{
            border-radius: 5em;
            padding-left: 10vw;
            padding-right: 10vw;
            margin-top: 5vh;
            margin-bottom: 10vh;
            min-height: 80vh;
            height: 80vh;
            max-width: 75vw;
        }
        .description{
            font-size: 1.6em;
            white-space: pre-wrap;
        }
        .explore{
            font-size: 40px;
        }
    }
    @media only screen and (max-width: 700px) {
        .eye{
            width: 6em;
            height: 2.8em;
        }
        .foodName{
            font-size: 2em;
        }
        .viewdetails{
            font-size: 1em;
        }
        .base{
            margin-top: 5vh;
            margin-bottom: 10vh;
            max-width: 70vw;
            height: 80vh;
        }
        .description{
            font-size: 1.4em;
            white-space: pre-wrap;
        }
        .explore{
            font-size: 2em;
        }
        .icons{
            min-width: 100%;
        }
    }
    @media only screen and (max-width: 400px){
        .foodName{
            font-size: 1.5em;
            margin: 0;
        }
        .base{
            border-radius: 2em;
            margin-top: 3.5vh;
            margin-bottom: 7vh;
            min-height: 80vh;
            height: 80vh;
        }
        .description{
            font-size: 1.25em;
            white-space: pre-wrap;
        }
        .explore{
            font-size: 1.5em;
        }
    }
    .viewbutton{
        background-color: transparent;
        border: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
    .viewbutton:focus{
        background-color: transparent;
        border: none;
    }
</style>